<form class="ask-question d-flex flex-column gap-16" [formGroup]="form">
  <p class="dialog-description m-0">{{ 'ASK_A_QUESTION_DESCRIPTION' | translate | capitalize }}</p>

  <div class="grid gap-16">
    <kendo-formfield class="g-col-12 g-col-md-6">
      <kendo-label labelCssClass="k-form-label" [for]="companyField" [text]="'COMPANY_NAME' | translate | capitalize" />
      <kendo-textbox #companyField class="ask-question__company" [value]="companyName()" [readonly]="true" />
    </kendo-formfield>
    <kendo-formfield class="g-col-12 g-col-md-6">
      <kendo-label labelCssClass="k-form-label" [for]="emailField" [text]="'EMAIL' | translate | capitalize" />
      <kendo-textbox #emailField class="ask-question__email" [value]="email()" [readonly]="true" />
    </kendo-formfield>
  </div>

  <kendo-formfield>
    <kendo-label labelCssClass="k-form-label" [for]="divisionField" [text]="'DIVISION' | translate | capitalize" />
    <kendo-dropdownlist
      #divisionField
      class="ask-question__division"
      formControlName="division"
      [data]="divisions"
      [defaultItem]="noDivision"
      textField="labelKey"
      valueField="value"
      [valuePrimitive]="true">
      <ng-template kendoDropDownListItemTemplate let-dataItem>
        {{ dataItem.labelKey | translate | capitalize }}
      </ng-template>
      <ng-template kendoDropDownListValueTemplate let-dataItem>
        {{ dataItem?.labelKey | translate | capitalize }}
      </ng-template>
    </kendo-dropdownlist>
  </kendo-formfield>

  <kendo-formfield>
    <kendo-label labelCssClass="k-form-label" [for]="messageField" [text]="'MESSAGE' | translate | capitalize" />
    <kendo-textarea
      #messageField
      class="ask-question__message"
      formControlName="message"
      resizable="vertical"
      [rows]="6"
      [maxlength]="maxLength" />
  </kendo-formfield>
</form>

<kendo-dialog-actions>
  <button kendoButton type="button" class="btn-white" (click)="cancel()">
    {{ 'CANCEL' | translate | capitalize }}
  </button>
  <button
    kendoButton
    type="button"
    themeColor="primary"
    iconClass="rc-icon-send"
    class="ask-question__send"
    [disabled]="form.invalid || isSending()"
    (click)="send()">
    {{ 'SEND' | translate | capitalize }}
  </button>
</kendo-dialog-actions>
